export default __webpack_public_path__ + "tab5_video_poster_m23fa52.png";